<script lang="ts">
  import { onMount, onDestroy, type Snippet } from "svelte"
  import { scale } from "svelte/transition"
  import { clickOutside } from "$app/attachments.svelte"

  let {
    closeOnOuterClick = true,
    open = $bindable(),
    onclose = () => {},
    button,
    children
  }: {
    closeOnOuterClick?: boolean
    open?: boolean
    button?: Snippet<[boolean]>
    onclose?: () => void
    children: () => any
  } = $props()

  const handleEscape = (event: KeyboardEvent) => {
    if (open && event.key === "Escape") {
      open = false
    }
  }

  onMount(() => {
    document.addEventListener("keyup", handleEscape, false)
  })
  onDestroy(() => {
    document.removeEventListener("keyup", handleEscape, false)
  })
</script>

<div
  class={["relative inline-block text-left dropdown", open ? "open" : ""]}
  {@attach clickOutside(() => {
    if (closeOnOuterClick) {
      open = false
    }
    onclose()
  })}
>
  <button
    onclick={(e) => {
      open = !open
    }}
    type="button"
    class={open ? "open" : ""}
  >
    {#if button}
      {@render button(open)}
    {:else}
      Open
    {/if}
  </button>
  {#if open}
    <div class="content" transition:scale>
      {@render children()}
    </div>
  {/if}
</div>

<style>
  :focus-visible {
    outline: none;
  }
  .content {
    position: absolute;
    right: 0px;
    height: 0;
    interpolate-size: allow-keywords;
    transition: height 0.5s ease;
  }
</style>
